(() => {
  if (customElements.get("slider-press")) return;

  class SliderPress extends HTMLElement {
    constructor() {
      super();
      this.mainSlider = null;
      this.thumbsSlider = null;
    }

    connectedCallback() {
      // DOM 완전히 붙은 뒤 실행
      requestAnimationFrame(() => this.init());
    }

    disconnectedCallback() {
      this.destroy();
    }

    init() {
      this.mainSliderElement = this.querySelector("[data-slider-main]");
      this.thumbsSliderElement = this.querySelector("[data-slider-thumbs]");

      if (!this.mainSliderElement || !this.thumbsSliderElement) return;

      const thumbsSlidesCount = Number(
        this.thumbsSliderElement.dataset?.slidesCount || 1
      );

      const safeSlidesPerView = Math.max(
        1,
        Math.min(3, thumbsSlidesCount)
      );

      this.mainSlider = new Swiper(this.mainSliderElement, {
        slidesPerView: 1,
        autoplay: {
          delay: 8000,
        },
        on: {
          slideChange: () => this.syncThumbsWithMain(),
        },
      });

      this.thumbsSlider = new Swiper(this.thumbsSliderElement, {
        slidesPerView: safeSlidesPerView,
        spaceBetween: 10,
        breakpoints: {
          990: {
            slidesPerView: Math.max(1, Math.min(2, thumbsSlidesCount)),
            spaceBetween: 0,
          },
        },
        on: {
          slideChange: () => this.syncMainWithThumbs(),
        },
      });

      this.addThumbClickHandlers();
    }

    destroy() {
      this.mainSlider?.destroy(true, true);
      this.thumbsSlider?.destroy(true, true);
      this.mainSlider = null;
      this.thumbsSlider = null;
    }

    syncThumbsWithMain() {
      if (!this.thumbsSlider) return;
      const activeIndex = this.mainSlider.activeIndex;
      this.thumbsSlider.slideTo(activeIndex);
      this.updateActiveThumb(activeIndex);
    }

    syncMainWithThumbs() {
      if (!this.mainSlider) return;
      const activeIndex = this.thumbsSlider.activeIndex;
      this.mainSlider.slideTo(activeIndex);
    }

    updateActiveThumb(activeIndex) {
      const slides = this.thumbsSlider.slides;
      slides.forEach(slide =>
        slide.classList.remove("swiper-slide-active")
      );
      slides[activeIndex]?.classList.add("swiper-slide-active");
    }

    addThumbClickHandlers() {
      this.thumbsSlider.slides.forEach((slide, index) => {
        slide.addEventListener("click", () => {
          this.mainSlider.slideTo(index);
        });
      });
    }
  }

  customElements.define("slider-press", SliderPress);
})();